export const COMMERCIAL_PHONE = '5511942340808'
export const OCTA_DESK_PHONE = '5511971956503'
